var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 141,
    viewBox: "0 0 1440 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M755.672 41.7378C743.161 52.9499 731.044 63.8087 719.353 70.4999C731.044 77.1911 743.161 88.0498 755.672 99.262C778.312 119.552 802.244 141 827.283 141C828.068 141 828.85 140.987 829.628 140.961C830.408 140.987 831.19 141 831.975 141H1440V4.66534e-05H831.975C831.19 4.65159e-05 830.409 0.0129155 829.63 0.0384544C828.851 0.0128847 828.068 6.87734e-08 827.283 0C802.244 -2.1924e-06 778.312 21.4475 755.672 41.7378Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M683.329 41.7378C695.839 52.95 707.956 63.8087 719.647 70.4999C707.956 77.1911 695.839 88.0498 683.329 99.262C660.688 119.552 636.756 141 611.718 141C610.933 141 610.152 140.987 609.374 140.961C608.594 140.987 607.811 141 607.025 141H0V0.000180606H607.025C607.809 0.000180537 608.591 0.0130284 609.369 0.0385255C610.149 0.0129137 610.932 7.81595e-06 611.718 7.81595e-06C636.756 7.81595e-06 660.688 21.4475 683.329 41.7378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.789bf1e29ee7a3ec1d5485394cbc51ed.svg";
export { ForwardRef as ReactComponent };